import styled from 'styled-components';

const AppStyles = styled.div`
  display: flex;
  min-height: 100vh;
  
  .gdrpaBar {
    position: fixed;
    bottom: 0;
    height: 20px;
    background-color: rgba(255, 255, 255, 0.6);
    width: 100%;
    
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 20px;
    
    a {
      color: #000;
    }
  }
`;

export default AppStyles;
